module.exports = __webpack_public_path__ + "static/media/gen_oth_san.838d9272.png";